<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="3 3 18.5 18">
    <path
      d="M5 3V19H21V21H3V3H5ZM21.5 13L20 14.5L16 10.5L13 13.5L7 7.5L8.5 6L13 10.585L16 7.5L21.5 13Z"
    />
  </svg>
</template>
